import actionTypes from 'SRC/modules/redux/actionTypes'

export const setLogo = (logo) => ({
  type: actionTypes.SET_REGISTRATION_LOGO,
  payload: logo
})
